import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import React, { useRef, useState } from 'react'
import { getNotifications } from '../chatSlice'
import { useHistory } from 'react-router-dom'
import Popup from 'components/popups/Popup'
import { useReduxDispatch } from 'store'
import { POST } from 'rest/request'
import { api } from 'rest/urls'
import './style.scss'

interface SendPhotoPopupProps extends chat.NotificationActionSendModal { }

const SendPhotoPopup: React.FC<SendPhotoPopupProps> = ({ title, description, request }) => {
  const [files, setFiles] = useState<FileList | null>(null)
  const [isSending, setSending] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)

  const { goBack } = useHistory()
  const { t } = useTranslation('chat')
  const dispatch = useReduxDispatch()
  const sendPhoto = async () => {
    if (isSending || !files) return
    setSending(true)
    try {
      const formData = new FormData()
      if (request.payload) {
        Object.entries(request.payload).forEach(([key, value]) => {
          formData.append(key, value)
        })
      }
      Array.from(files).forEach((file, idx) => formData.append(`documents[${idx}]`, file))
      const response = await POST(`${api}${request.url}`, { form: formData })
      if (response?.result === 'ok') {
        dispatch(getNotifications())
        goBack()
      } else {
        throw new Error('Wrong response :/')
      }
    } catch (error) {
      setSending(false)
    }
  }

  return (
    <Popup>
      <div className='popup__sendPhoto'>
        <div className='popup__title'>
          <div>{title}</div>
          <div>{description}</div>
        </div>

        <div style={{ display: 'none' }}>
          <input
            disabled={isSending}
            ref={inputRef}
            type='file'
            accept='image/*'
            // capture='camera'
            onChange={e => {
              const { files } = e.target
              if (files) setFiles(files)
            }}
          />
        </div>

        <div className='popup__sendPhoto__photo center'>
          <div
            className='center'
            onClick={() => {
              inputRef.current?.click()
            }}>
            {files?.[0]
              ? <img
                alt='photo_preview'
                src={URL.createObjectURL(files?.[0])} />
              : <i className='icon icon--plus s32' />}
          </div>
        </div>

        <div className='popup__sendPhoto__buttons'>
          <ArrowBtn
            enlarged
            disabled={isSending}
            text={files && files.length > 0
              ? files.length > 1
                ? `${t('add')} ${files.length} ${t(files.length < 5 ? 'files<5' : 'files>=5')}`
                : `${t('add')} ${files?.[0]?.name}`
              : t('takeAPicture')}
            action={() => {
              if (files && files?.length > 0) {
                sendPhoto()
              } else {
                inputRef.current?.click()
              }
            }}
          />
          <BackBtn />
        </div>
      </div>
    </Popup>
  )
}

export default SendPhotoPopup